import React from "react";
import HorizontalLoader from "../../common/loading-widgets/HorizontalLoader.js";
import WaitForData from "../../common/data-fetching/WaitForData.js";
import ReportProblemOutlined from "@mui/icons-material/ReportProblemOutlined";
import useQueryApplicationByCandidateIdCount from "./useQueryApplicationByCandidateIdCount.js";
import useTranslationCandidates from "../useTranslationCandidates.js";
import useShowLoader from "../../common/loading-widgets/useShowLoader.js";
import StringUtils from "../../../utils/StringUtils.js";

export default function JobTitleItem(props) {
  const { candidateId } = props;
  const { t, loading: tLoading } = useTranslationCandidates();

  useShowLoader(tLoading, "ApplicationCountItem");
  const { data: count, loading, errors } = useQueryApplicationByCandidateIdCount(
    candidateId
  );

  return (
    <HorizontalLoader>
      <WaitForData
        loading={loading}
        errors={errors}
        onError={() => <ReportProblemOutlined className="LoadingError" />}
        onLoaded={() => (
          <span>
            {t("candidates:candidates_application_count", {
              count: StringUtils.nullToZero(count),
            })}
          </span>
        )}
      />
    </HorizontalLoader>
  );
}
